<template>
	<div id="songs-side" :class="{ 'side-opened': sideOpened, 'pulling': pulling }" :style="{ 'left' : sidePulledLeft }">
		<SongsFilter />
		<Songs />
		<HelpMoreSongs v-if="showHelpMoreSongs" />
		<br><br><br>
	</div>
</template>

<script>
	import Songs from "./Songs";
	import SongsFilter from "./SongsFilter";
	import { mapState } from "vuex";
	import HelpMoreSongs from "./HelpMoreSongs";

	export default {
		data() {
			return {
			};
		},
		components: {
			HelpMoreSongs,
			Songs, SongsFilter
		},
		computed: {
			...mapState([ "sideOpened", "sidePulled" ]),
		},
		recomputed: {
			sidePulledLeft() {
				if (this.sideOpened) return 0;
				return (this.sidePulled - 260) + "px";
			},
			pulling() {
				return this.sidePulled > 0;
			},
			showHelpMoreSongs() {
				return Object.values(this.$store.state.songs).length < 7;
			}
		},
		methods: {
			pullingSide() {
				this.$recompute("sidePulledStyle");
				this.$recompute("pulling");
			}
		},
		mounted() {
			document.addEventListener("PullingSide", this.pullingSide);
		},
		destroyed() {
			document.removeEventListener("PullingSide", this.pullingSide);
		}
	}
</script>

<style lang="scss" scoped>
	#songs-side {
		background-color: #264653;
		height: calc(100vh - 50px);
		width: 260px;
		position: fixed;
		z-index: 1;
		top: 50px;
		top: calc(constant(safe-area-inset-top) + 50px);
		top: calc(env(safe-area-inset-top) + 50px);
		left: -260px;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;

		&.side-opened {
			left: 0;
		}

		-webkit-transition: left 0.2s;
		-moz-transition: left 0.2s;
		-o-transition: left 0.2s;
		transition: left 0.2s;

		&::-webkit-scrollbar {
			width: 8px;
		}

		&.pulling {
			-webkit-transition: none;
			-moz-transition: none;
			-o-transition: none;
			transition: none;
		}

		&::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
			background-color: rgba(59, 115, 135, 0.26);
		}

		&::-webkit-scrollbar-thumb {
			background-color: rgba(42, 157, 143, 0.7);
		}
	}

	.icon-menu {
		padding: 9px 15px;
	}
</style>
